import * as React from "react"
import {useEffect} from "react"
import {Box} from "@mui/material";

import {MATCHERS_ROUTES} from "@constants";
import PageWrapper from "../../@PageWrapper";
import {MatchersSkeleton} from "../@components";
import {useMatchersSKUsItems} from "./@hooks";
import {clearMatchersSKUsSignals, isMatcherSKUsLoading} from "./@signals";
import MatchersSKUsContent from "./Content";
import MatchersSKUsDrawer from "./DrawerSku";


export default function MatchersSKUsPage() {
	const { handleSubmit } = useMatchersSKUsItems()

	useEffect(() => {
		handleSubmit()
		return clearMatchersSKUsSignals
	}, [])

	return <PageWrapper head={`SKU Mapper | ${MATCHERS_ROUTES.SKUS_SUBTITLE}`} title="SKU Mapper" subtitle={MATCHERS_ROUTES.SKUS_SUBTITLE}>
		<Box width={1} height={1} position="relative" top={20}>
			{ isMatcherSKUsLoading.value
				? <MatchersSkeleton />
				: <MatchersSKUsContent />
			}
		</Box>

		<MatchersSKUsDrawer />
	</PageWrapper>
}